import { useMutation } from '@tanstack/react-query';

import * as api from './PublicationApi';
import { PublicationSearchRequest, ReclaimRequest } from './PublicationTypes';

export function useSearchPublicationByIdentifiers() {
  return useMutation({
    mutationFn: (request: PublicationSearchRequest) => api.searchByIdentifiers(request),
  });
}

export function useReclaimAuthorship() {
  return useMutation({
    mutationFn: ({ publicationId, authorId }: ReclaimRequest) => api.reclaimAuthorship(publicationId, authorId),
  });
}
